module.exports = "<span *ngIf=\"contract.eshopId\" class=\"badge badge-pill badge-primary eshop\">\n    <a matTooltip=\"Zobrazit poptávku\" href=\"{{ this.eshopUrl }}/#/orders/{{ contract.eshopId }}\" target=\"_blank\">Eshop</a>\n</span>\n\n<span *ngFor=\"let s of states\">\n    <span *ngIf=\"s.object === contract.state\" class=\"badge badge-pill badge-primary {{s.id}}\">\n        {{s.name}}\n    </span>\n</span>"


//////////////////
// WEBPACK FOOTER
// /app/src/SharedModule/ContractStateComponent/contract-state.component.html
// module id = ../../../../../src/SharedModule/ContractStateComponent/contract-state.component.html
// module chunks = main